<template>
  <div class="section billing-enrollee-detail">
    <div class="card z-depth-0 billing-work-card">
      <div class="card-content billing-member-panel" v-if="enrollee">
        <!-- Main -->
        <div class="row">
          <div class="col s8">
            <p class="billing-member-client">{{ capWords(enrollee.client_name) }}</p>
            <h5>
              {{ capWords(enrollee.name) }}
              <sup>{{ showAgeSex(enrollee.dob, enrollee.sex) }}</sup> &nbsp;
              <a href="#" class="billing-member-close" title="Leave encounter" aria-label="Leave encounter"
                @click.prevent="handleBack()"><i class="material-icons">close</i></a>
            </h5>
            <p class="billing-member-id">{{ enrollee.enrollee_number }}</p>
            <span v-if="!forDelete">
              <span v-if="enrollee && 'encounter_date' in enrollee">
                <p>
                  <br />
                  <span class="chip blue-grey lighten-4">
                    {{
                      new Date(enrollee.encounter_date).toLocaleString(undefined, {
                        weekday: "long",
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      })
                    }}
                  </span>

                  <span class="chip teal lighten-4" v-if="enrollee && enrollee?.encounter_date_end">
                    {{
                      new Date(enrollee.encounter_date_end).toLocaleString(undefined, {
                        weekday: "long",
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      })
                    }}
                  </span> <i class="tiny material-icons red-text clickable" title="Reset date"
                    @click="handleDateReset()" v-if="!enrollee?.encounter_date_set">cancel</i>
                </p>
              </span>
              <span v-else>
                <p>Encounter Dates <em>not</em> set</p>
              </span>
            </span>
          </div>

          <div class="col s4">
            <img :src="enrollee.profile_img" width="96" class="circle responsive-img right"
              v-if="enrollee.profile_img" />
            <img :src="`https://ui-avatars.com/api/?name=${enrollee.name}&background=random&size=128`" width="96"
              class="circle responsive-img right" v-else />
          </div>
        </div>

        <div class="row billing-delete-panel" v-if="forDelete">
          <p><br /></p>
          <div class="col s12">
            <a class="waves-effect waves-light btn-large teal left" title="Back" :class="{ 'disabled': isSubmitting }"
              @click.prevent="handleDeleteEncounter('back')">
              <i class="medium material-icons left">chevron_left</i>Go back
            </a>

            <a class="waves-effect waves-light btn-large red right" title="Delete All"
              :class="{ 'disabled': isSubmitting }" @click.prevent="handleDeleteEncounter('confirm_delete')">
              <i class="medium material-icons left">delete</i>Confirm Delete for {{ capWords(enrollee.name) }}
            </a>
          </div>
          <p><br /></p>
        </div>
      </div>

      <!-- Search Enrollee -->
      <template v-if="!enrollee">

        <template v-if="!enrolleeSearch">

          <div class="card-panel billing-operation-panel" :class="{ 'red lighten-5': error }">
          <div class="row">
            <div class="col s3">
              <div class="input-field">
                <input type="text" id="enrolleeId" v-model="enrolleeId" />
                <label for="enrolleeId">Enrollee ID</label>
              </div>
            </div>
            <div class="col s6">
              <div class="input-field">
                <input type="text" id="enrolleeName" v-model="enrolleeName" />
                <label for="enrolleeName">Enrollee Name</label>
              </div>
            </div>
            <div class="col s3">
              <p>
                <button class="waves-effect waves-light btn-large right" :class="{
                  disabled: !enrolleeId || !enrolleeName,
                }" @click="handleAddEnrollee">
                  <i class="material-icons right" v-if="!isLoading">chevron_right</i> Next
                </button>
              </p>
            </div>
            <div clas="row" v-if="error">
              <div class="col s12">
                <span class="left badge red white-text text-darken-2">{{ error }}</span>
              </div>
            </div>
          </div>
        </div>
        </template>

        <template v-else>
        <!-- Single Search -->
        <div class="card-panel billing-operation-panel" :class="{ 'red lighten-5': error }">
          <div class="row">
            <div class="col s12 m1 clickable" @click.prevent="handleBack()"><i class="large material-icons right" title="Go Back">chevron_left</i></div>
            <div class="col s12 m8">
              <div class="input-field">
                <input type="text" id="enrolleeId" v-model="enrolleeId" @focus="handleClearID('id')" />
                <label for="enrolleeId">Enrollee ID</label>
                <div class="progresss" v-if="isLoading">
                  <div class="indeterminate"></div>
                </div>
              </div>
            </div>
            <div class="col s12 m3">
              <p>
                <button class="waves-effect waves-light btn-large right" :class="{
                  disabled: !enrolleeId || isLoading,
                }" @click="handleSearch">
                  <i class="material-icons right" v-if="!isLoading">chevron_right</i>{{ isLoading ? "Searching..." :
                    "Search" }}
                </button>
              </p>
            </div>
            <div clas="row" v-if="error">
              <div class="col s12">
                <span class="left badge red white-text text-darken-2">{{ error }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Confirmation for more than multiple enrollees -->
        <div class="card billing-enrollee-option" v-for="enrollee in enrolleeGroup" :key="enrollee.id">
          <div class="card-content">
            <div class="row">
              <div class="col s10">
                <p class="grey-text text-darken-2">{{ cluster.month.name }} {{ cluster.year.name }} List</p>
                <h5>{{ capWords(enrollee?.name) }} <small>({{ enrollee?.enrollee_number }})</small></h5>
                <span class="new badge left grey darken-2" data-badge-caption="Scheme">{{
                  String(enrollee?.scheme?.name ?? "Scheme not recorded").toUpperCase()
                }}</span>
              </div>
              <div class="col s2">
                <a class="btn-floating btn-large waves-effect waves-light light-blue lighten-2 billing-option-action right"><i
                    class="material-icons" @click.prevent="handleStart(enrollee)" title="details">chevron_right</i></a>
              </div>
            </div>
          </div>
        </div>
        </template>
      </template>
      <!-- End Search Enrollee -->

      <div v-else>
        <!-- Encounter Starts: Date Form -->
        <div class="card-panel billing-operation-panel" :class="{ 'red lighten-5': error }" v-if="!enrollee?.encounter_date">
          <div class="row">
            <div class="col s12">
              <span class="card-title">Start <em>of</em> Encounter</span>
            </div>
            <div class="col s5 m3">
              <div class="input-field">
                <input type="text" id="enounterDate" v-model="encounterDate" @focus="handleClearID('date')" />
                <label for="encounterDate">Day</label>
              </div>
            </div>
            <div class="col s7 m3">
              <div class="input-field">
                <input type="text" id="month" :value="cluster.month.name" disabled />
                <label class="active" for="month">Month</label>
              </div>
            </div>
            <div class="col s5 m3">
              <div class="input-field">
                <input type="text" id="year" :value="cluster.year.name" disabled />
                <label class="active" for="year">Year</label>
              </div>
            </div>
            <div class="col s7 m3">
              <p>
                <button class="waves-effect waves-light btn-large right" :class="{
                  disabled: !encounterDate || isLoading,
                }" @click="handleEncounterDate">
                  <i class="material-icons right">{{
                    isLoading ? "hourglass_empty" : "chevron_right"
                  }}</i>{{ isLoading ? "Going..." : "Next" }}
                </button>
              </p>
            </div>
          </div>
        </div>

        <!-- Encounter Ends: Date Form -->
        <template v-if="(enrollee?.encounter_date && !enrollee?.encounter_date_end)">
          <!-- Selections -->
          <div class="card-panel billing-operation-panel" :class="{ 'red lighten-5': error }">
            <div class="row" v-if="addOns">
              <div class="col s12">
                <span class="card-title">Special Fields</span>
              </div>
              <div class="col s12">
                <div class="input-field">
                  <input type="text" id="doctor" v-model="doctor" required />
                  <label class="active orange-text text-darken-2" for="doctor">Attending Doctor (*)</label>
                </div>
              </div>
              <div class="col s12">
                <div class="input-field">
                  <input type="text" id="age" v-model="patientAge" />
                  <label class="active teal-text text-darken-2" for="age">Patient Age</label>
                </div>
              </div>
              <div class="col s12">
                <div class="input-field">
                  <input type="text" id="complaint" v-model="presentingComplaint" />
                  <label class="active teal-text" for="complaint">Presenting Complaints</label>
                </div>
              </div>
              <div class="col s12">
                <div class="input-field">
                  <input type="text" id="finding" v-model="examinationFinding" />
                  <label class="active teal-text" for="finding">Examination Finding</label>
                </div>
              </div>
              <div class="col s12">
                <div class="input-field">
                  <input type="text" id="finding" v-model="requestedInvestigation" />
                  <label class="active teal-text" for="investigations">Investigations (copy)</label>
                </div>
              </div>
              <div class="col s12">
                <p>
                  <button class="waves-effect waves-light btn-large right" :class="{
                    disabled: !doctor || isLoading
                  }" @click="handleSpecial()">
                    <i class="material-icons right">{{
                      isLoading ? "hourglass_empty" : "chevron_right"
                      }}</i>{{ isLoading ? "Adding..." : "Add" }}
                  </button>
                </p>
              </div>
            </div>
            <div class="row" v-else>
              <div class="col s12">
                <span class="card-title">End <em>of</em> Encounter</span>
              </div>
              <div class="col s5 m3">
                <div class="input-field">
                  <input type="text" id="enounterDateEnd" v-model="encounterDateEnd" @focus="handleClearID('date')" />
                  <label class="active" for="encounterDateEnd">Day</label>
                </div>
              </div>
              <div class="col s7 m3">
                <div class="input-field">
                  <FilterSimpleDiv inputId="filterDurationMonth" fieldName="Select Month"
                    :data="filterDurationMonthData" :placeHolder="selectedDurationMonth?.name" :search="false"
                    @selected="handlePick" />
                </div>
              </div>
              <div class="col s5 m3">
                <div class="input-field">
                  <FilterSimpleDiv inputId="filterDurationYear" fieldName="Select Year" :data="filterDurationYearData"
                    :placeHolder="selectedDurationYear?.name" :search="false" @selected="handlePick" />
                </div>
              </div>
              <div class="col s7 m3">
                <p>
                  <button class="waves-effect waves-light btn-large right" :class="{
                    disabled: !encounterDateEnd || !selectedDurationMonth || !selectedDurationYear || isLoading,
                  }" @click="handleEncounterDateEnd()">
                    <i class="material-icons right">{{
                      isLoading ? "hourglass_empty" : "chevron_right"
                      }}</i>{{ isLoading ? "Setting ..." : "Set" }}
                  </button>
                </p>
              </div>
            </div>
          </div>
          <!-- Claims Summary -->
          <div class="card-content billing-inline-summary" v-if="enrollee?.encounter_date_set">
            <!-- <span class="card-title">Summary</span> -->
            <ol id="item-list" class="collection">
              <li class="collection-item" v-for="claim in enrollee?.claims" :key="claim.id">
                <span v-if="claim.status === 'a'">
                  <b>{{ capWords(claim.claim) }}</b> x {{ claim.qty }} (<em>Sent Amount</em>: ₦{{
                    formatClaimAmount(claim)
                  }})
                  <span class="chip billing-auto-fee-badge" v-if="isProfessionalFeeClaim(claim)">Auto</span>
                  <span class="chip blue lighten-5 pointable" v-if="claim.amt == 0 && claim.authorization !== 'y'"
                    title="capitated item">Cap</span>

                  <!-- Reviewed claim -->
                  <span class="brown-text" v-if="hasClaimAuthorization(claim)">
                    <b> => </b>
                    <span class="blue-text tooltipped pointable" data-position="top" :data-tooltip="claim.comment"
                        v-if="claim.comment"> ({{
                          claim.authorization_code }}) </span>
                    <span class="black-text" v-else> ({{ claim.authorization_code }}) </span>
                  </span>
                </span>
                <span v-if="claim.status === 'd'">
                  <s>{{ capWords(claim.item) }} x {{ claim.sent_qty }} (Amount Sent: ₦{{
                    Number(claim.sent_price)
                      .toFixed(2)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }})</s>
                  <b><span class="info-item tooltipped pointable" data-position="top"
                      :data-tooltip="capWords(claim.comment)">
                      <i class="material-icons grey-text">help</i>
                    </span></b>
                </span>
              </li>
            </ol>
          </div>
        </template>

        <div class="progresssave" v-if="isLoading">
          <div class="indeterminate"></div>
        </div>

        <div id="claim"></div>

        <!-- Displays -->
        <template v-if="enrollee?.encounter_date_end && !forDelete">
          <!-- Diagnosis -->
          <div class="billing-clinical-stack" v-if="billingDiagnosisList.length">
            <div class="col s12">
              <div class="billing-diagnosis-card">
                <i class="material-icons billing-card-icon">bookmark_border</i>
                <span>
                  <small>Diagnosis</small>
                  <strong>{{ billingDiagnosisList.join(", ").toUpperCase() }}</strong>
                    <a href="#" class="secondary-content edit-black-item right" v-if="cluster?.status === 'q'">
                      <i class="small material-icons" :class="{
                        'black-text': !resetDiagnosis,
                        'blue-text': resetDiagnosis,
                      }" title="edit diagnosis" @click.prevent="handleReviewDiagnosis"
                        v-if="canReviewDiagnosis">edit</i>
                      <i class="small material-icons pointable" title="locked" v-else>lock</i>
                    </a>
                </span>
              </div>
            </div>
            <template v-if="enrollee?.scheme_id === 3">
              <!-- Addons -->
              <!-- doctor loaded means review was clicked -->
              <div class="row card-content billing-operation-panel" v-if="doctor">
                <div class="col s12">
                  <br />
                </div>
                <div class="col s12">
                  <span class="card-title">Update Patient Record</span>
                </div>
                <div class="col s12">
                  <div class="input-field">
                    <input type="text" id="doctor" v-model="doctor" required />
                    <label class="active orange-text text-darken-2" for="doctor">Attending Doctor (*)</label>
                  </div>
                </div>
                <div class="col s12">
                  <div class="input-field">
                    <input type="text" id="age" v-model="patientAge" />
                    <label class="active teal-text text-darken-2" for="age">Patient Age</label>
                  </div>
                </div>
                <div class="col s12">
                  <div class="input-field">
                    <input type="text" id="complaint" v-model="presentingComplaint" />
                    <label class="active teal-text" for="complaint">Presenting Complaints</label>
                  </div>
                </div>
                <div class="col s12">
                  <div class="input-field">
                    <input type="text" id="finding" v-model="examinationFinding" />
                    <label class="active teal-text" for="finding">Examination Finding</label>
                  </div>
                </div>
                <div class="col s12">
                  <div class="input-field">
                    <input type="text" id="finding" v-model="requestedInvestigation" />
                    <label class="active teal-text" for="investigations">Investigations (copy)</label>
                  </div>
                </div>
                <div class="col s12">
                  <p>
                    <button class="waves-effect waves-light btn-large blue darken-1 right" :class="{
                      disabled: !doctor || isLoading
                    }" @click="handleAddOn()">
                      <i class="material-icons right">{{
                        isLoading ? "hourglass_empty" : "chevron_right"
                        }}</i>{{ isLoading ? "Updating..." : "Update" }}
                    </button>
                  </p>
                </div>
              </div>
              <!-- Addons display -->
              <div class="col s12" v-else>
                <div class="card-content billing-addon-card">
                  <a href="#" class="secondary-content edit-black-item right">
                    <i class="small orange-text text-darken-2 material-icons" title="redo"
                      @click.prevent="handleReviewAddOn()">autorenew</i>
                  </a>
                  <span class="black-text">
                    <p>
                      Attending Doctor: {{ enrollee?.stores?.doctor }}
                    </p>
                    <p>
                      Patient Age: {{ enrollee?.stores?.age }}
                    </p>
                    <p>
                      Presenting Complaints: {{ enrollee?.stores?.complaint }}
                    </p>
                    <p>
                      Examination Finding: {{ enrollee?.stores?.finding }}
                    </p>
                    <p>
                      Investigations: {{ enrollee?.stores?.investigation }}
                    </p>
                  </span>
                </div>
              </div>
            </template>
          </div>

          <!-- Add claim -->
          <section class="billing-add-provider-frame" ref="diagnosisEditor">
            <AddClaimProvider
              :turl="tariffLookup" :type="type"
              :next="next" :editDiagnosis="resetDiagnosis" :claimItem="claim" :reload="enrollee"
              :isManualBilling="isManualBillingCluster" @update="handleUpdate"
              @claims-updated="handleClaimsUpdated"
              @diagnosis-saved="handleDiagnosisSaved"
              @clear="handleClear" />
          </section>

          <!-- Claims -->
          <div class="card billing-items-card" v-if="claimsDisplayCard">
            <div class="card-content">
              <div class="billing-items-head">
                <span class="card-title">Item(s)</span>
                <span class="chip orange-text text-accent-3 pointable" :title="enrollee.picked_provider"
                  v-if="enrollee?.scheme_id === 3 && enrollee.picked_provider_id && enrollee.provider_id && enrollee.picked_provider_id !== enrollee.provider_id">
                  Referral </span>

                <a class="btn-medium waves-effect waves-light red lighten-2 secondary-content chip right"
                  v-if="enrollee?.scheme_id === 3"><i class="material-icons white-text" @click.prevent="handleDownload()"
                    title="download encounter">download</i>
                </a>
              </div>

              <!-- List claims -->
              <ol id="item-list" class="collection billing-item-list">
                <li class="collection-item billing-item-row" :class="{ 'is-delete-pending': pendingDeleteId == claim.id }"
                  v-for="claim in claims" :key="claim.id">

                  <!-- Approved Items -->
                  <span class="billing-line-copy" v-if="claim.status == 'a'">
                    <b>{{ capWords(claim.claim) }}</b> x {{ claim.qty }} (<em>Sent Amount</em>: ₦{{
                      formatClaimAmount(claim)
                    }})
                    <span class="chip billing-auto-fee-badge" v-if="isProfessionalFeeClaim(claim)">Auto</span>
                    <span class="chip blue lighten-5 pointable" v-if="claim.amt == 0 && claim.authorization !== 'y'"
                      title="capitated item">Cap</span>

                    <!-- Reviewed claim -->
                    <span class="brown-text" v-if="hasClaimAuthorization(claim)">
                      <b> => </b>
                      <span class="blue-text tooltipped pointable" data-position="top" :data-tooltip="claim.comment"
                        v-if="claim.comment"> ({{
                          claim.authorization_code }}) </span>
                      <span class="black-text" v-else> ({{ claim.authorization_code }}) </span>
                    </span>

                    <span class="claim-remove-confirm" v-if="pendingDeleteId == claim.id">
                      <span>Remove item?</span>
                      <button type="button" class="claim-remove-confirm-yes"
                        @click.prevent="handleDeleteConfirm(claim)">Yes remove</button>
                      <button type="button" class="claim-remove-confirm-no"
                        @click.prevent="handleDeleteCancel">No</button>
                    </span>

                    <span class="hide-on-small-only" v-if="cluster.status === 'q' && !isProfessionalFeeClaim(claim)">
                      <a href="#" class="secondary-content cancel-item" @click.prevent="handleDeleteRequest(claim)"
                        title="Remove item"><i class="material-icons" :class="{
                          'grey-text': deleteId != claim.id && pendingDeleteId != claim.id,
                          'red-text': deleteId == claim.id || pendingDeleteId == claim.id,
                        }">cancel</i></a>
                    </span>
                  </span>

                  <!-- Deleted Items -->
                  <span class="billing-line-copy" v-else>
                    <s>{{ capWords(claim.item) }} x {{ claim.sent_qty }} (Amount Sent: ₦{{
                      Number(claim.sent_price)
                        .toFixed(2)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }})</s>
                    <b><span class="info-item tooltipped pointable" data-position="top"
                        :data-tooltip="capWords(claim.comment)">
                        <i class="material-icons grey-text">help</i>
                      </span></b>

                    <span class="claim-remove-confirm" v-if="pendingDeleteId == claim.id">
                      <span>Remove item?</span>
                      <button type="button" class="claim-remove-confirm-yes"
                        @click.prevent="handleDeleteConfirm(claim)">Yes remove</button>
                      <button type="button" class="claim-remove-confirm-no"
                        @click.prevent="handleDeleteCancel">No</button>
                    </span>

                    <span class="hide-on-small-only" v-if="cluster.status === 'q' && !isProfessionalFeeClaim(claim)">
                      <a href="#" class="secondary-content cancel-item" @click.prevent="handleDeleteRequest(claim)"
                        title="Remove item"><i class="material-icons" :class="{
                          'grey-text': deleteId != claim.id && pendingDeleteId != claim.id,
                          'red-text': deleteId == claim.id || pendingDeleteId == claim.id,
                        }">cancel</i></a>
                    </span>
                  </span>

                </li>
              </ol>

              <div class="billing-add-state-helper" v-if="cluster.status === 'q' && claimsDisplayCard && !claimsSubmitCard && claims.length">
                <button type="button" class="billing-add-state-link" @click.prevent="handleContinueReviewInPlace">
                  <i class="material-icons">keyboard_arrow_up</i>
                  <span>Continue to review</span>
                </button>
              </div>

              <!-- Claims Submit -->
              <div v-if="claimsSubmitCard">
                <!-- Total -->
                <ul id="item-list" class="collection billing-total-list">
                  <li class="collection-item pull-right billing-total-row">
                    <b>Total</b> (Sent Amount):
                    <b><span class="blue-text text-darken-2">₦{{ totalSent() }}</span></b>
                  </li>
                </ul>

                <div class="billing-completion-error" role="alert" v-if="completionError">
                  {{ completionError }}
                </div>

                <!-- Submit -->
                <span class="row billing-action-strip" v-if="cluster.status === 'q'">
                  <span class="billing-action-left-group">
                    <a class="waves-effect waves-light btn-large billing-action-button billing-danger-action"
                      title="Delete All"
                      :class="{ 'disabled': isLoading || deleteId || cluster?.status !== 'q' || enrollee?.encounter_date_set }"
                      @click.prevent="handleDeleteEncounter('delete')">
                      <i class="material-icons">delete</i>Delete</a>

                    <a class="waves-effect waves-light btn-large billing-action-button billing-dark-action"
                      :class="{ 'disabled': isLoading || deleteId || cluster?.status !== 'q' }"
                      @click.prevent="handleNext('moreClaims')">
                      <i class="material-icons">add</i>Add Item</a>
                  </span>

                  <a class="waves-effect waves-light btn-large billing-action-button billing-primary-action"
                    :class="{ 'disabled': isLoading || deleteId, 'billing-primary-ready': enrollee?.status === 'q', 'billing-primary-muted': enrollee?.status !== 'q' }"
                    @click.prevent="handleSubmit(true, true)" v-if="enrollee?.encounter_date_set">
                    <span v-if="enrollee?.status === 'q'"><i
                        class="material-icons">check_circle</i>Complete</span>
                    <span v-else><i class="material-icons">chevron_right</i>Okay</span>
                  </a>

                  <a class="waves-effect waves-light btn-large billing-action-button billing-primary-action billing-primary-ready"
                    :class="{ 'disabled': isLoading || deleteId }" @click.prevent="handleCreate()" v-else>
                    <i class="material-icons">check_circle</i>Complete
                  </a>
                </span>
              </div>
            </div>
          </div>

          <div class="billing-back-row" v-if="claimsDisplayCard">
            <a href="#" class="billing-back-link" @click.prevent="handleBack()">
              <i class="material-icons">arrow_back</i>
              <span>Go back to billing list</span>
            </a>
          </div>

          <!-- Sumbmitting -->
          <div class="progress" v-if="isSubmitting || deleteId">
            <div class="indeterminate"></div>
          </div>

        </template>

        <section class="billing-empty-encounter" v-if="canRemoveEmptyEncounter && !forDelete">
          <button type="button" class="billing-empty-encounter-trigger" :disabled="isRemovingEncounter"
            @click="confirmEmptyEncounterRemoval = true" v-if="!confirmEmptyEncounterRemoval">
            <i class="material-icons">delete_outline</i>
            <span>Remove this encounter completely</span>
          </button>

          <div class="billing-empty-encounter-confirm" v-else>
            <div>
              <strong>Remove this empty encounter?</strong>
              <p>It will be removed from this billing batch.</p>
            </div>
            <div class="billing-empty-encounter-actions">
              <button type="button" class="billing-empty-encounter-cancel" :disabled="isRemovingEncounter"
                @click="confirmEmptyEncounterRemoval = false">Cancel</button>
              <button type="button" class="billing-empty-encounter-remove" :disabled="isRemovingEncounter"
                @click="handleRemoveEmptyEncounter">
                <i class="material-icons">delete_forever</i>
                {{ isRemovingEncounter ? "Removing..." : "Remove encounter" }}
              </button>
            </div>
          </div>

          <p class="billing-empty-encounter-error" role="alert" v-if="removeEncounterError">
            {{ removeEncounterError }}
          </p>
        </section>
      </div>

    </div>
  </div>
</template>


<script>
import { ref, onMounted, computed, watchEffect, nextTick } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { ageSex, capWordsFx } from "@/composables/fxLibrary/coreFx";
import { totalSentInputFx } from "@/composables/calFunction/cal";
import getItemsOfItems from "@/composables/getItemsOfItems";
import putItem from "@/composables/putItem";
import { removeEmptyBillingEncounter, addEncounterWithClaims } from "@/composables/serverCaller/serverCaller";
import AddClaimProvider from "@/components/claim/AddClaimProviderComponent.vue";
import FilterSimpleDiv from "@/components/search/FilterSimpleDiv.vue";
import { normalizeEnrolleeNumber, normalizeEnrolleeSearchValue } from "@/composables/enrolleeNumber";
import M from "materialize-css";

export default {
  name: "EnrolleeBillComponent",
  props: ["cluster", "encounter"],
  emits: ["next", "back", "updated", "draft", "draft-clear", "removed"],
  components: { AddClaimProvider, FilterSimpleDiv },
  setup(props, context) {
    const lock = ref(true);
    const addOns = ref(false); // for all schemes at first!
    const enrolleeSearch = ref(false); //use manual for now
    const doctor = ref(null);
    const patientAge = ref(null);
    const presentingComplaint = ref(null);
    const examinationFinding = ref(null);
    const requestedInvestigation = ref(null);
    const isLoading = ref(false);
    const isSubmitting = ref(false);
    const response = ref(null);
    const responseDurationYearDefault = ref(null);
    const responseDurationMonthDefault = ref(null);
    const enrolleeGroup = ref([]);
    const enrolleeName = ref(null);
    const enrolleeId = ref(null);
    const encounterDate = ref(null);
    const encounterDateEnd = ref(null);
    const error = ref(false);
    const editId = ref(null);
    const editClaim = ref(null);
    const forDelete = ref(false);
    const deleteId = ref(null);
    const deleteClaim = ref(null);
    const pendingDeleteId = ref(null);
    const submitPulse = ref(false);
    const selectedItem = ref(null);
    const selectedDurationYear = ref(null);
    const selectedDurationMonth = ref(null);
    const claimsDisplayCard = ref(false);
    const claimsSubmitCard = ref(false);
    const diagnosisList = ref([]);
    const completionError = ref("");
    const confirmEmptyEncounterRemoval = ref(false);
    const isRemovingEncounter = ref(false);
    const removeEncounterError = ref("");
    const resetDiagnosis = ref(false);
    const diagnosisEditor = ref(null);
    const type = ref("claim"); // keep claim open after input
    const next = ref("next");
    const claimsList = ref([]);
    const claim = ref(null);
    const cache = ref({});
    const healthClaimForm = ref(null);

    const isManualScheme = (scheme) => {
      return scheme?.is_manual === true || scheme?.is_manual === 1 || scheme?.is_manual === "1";
    };

    const isManualBillingCluster = computed(() => {
      return isManualScheme(props.cluster?.scheme);
    });

    const tariffLookup = computed(() => ({
      payerId: response.value?.payer_id,
      sid: props.cluster?.scheme_id,
      pid: props.cluster?.provider_id,
    }));

    const billingDiagnosisList = computed(() => {
      if (response.value?.encounter_date_set) {
        const savedDiagnosis = String(response.value?.diagnosis || "").trim();
        return savedDiagnosis ? [savedDiagnosis] : [];
      }

      return diagnosisList.value
        .map((entry) => String(entry || "").trim())
        .filter(Boolean);
    });

    const hasBillingDiagnosis = () => {
      return billingDiagnosisList.value.length > 0;
    };

    const emitEncounterUpdated = () => {
      if (response.value?.id && response.value?.encounter_date_set) {
        context.emit("updated", response.value);
      }
    };

    const canRemoveEmptyEncounter = computed(() => {
      const hasClaimItems = (response.value?.claims || []).some(
        (claimItem) => !isProfessionalFeeClaim(claimItem),
      );

      return Boolean(
        response.value?.id
        && response.value?.encounter_date_set
        && props.cluster?.status === "q"
        && !response.value?._draft
        && !hasClaimItems
      );
    });

    const requireBillingDiagnosis = async () => {
      completionError.value = "Add a diagnosis before completing this billing encounter.";
      await nextTick();

      const editorCard = diagnosisEditor.value?.querySelector(".provider-diagnosis-card");
      if (editorCard) {
        const top = editorCard.getBoundingClientRect().top + window.scrollY - 104;
        window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
      }
    };

    // vue router
    const router = useRouter();

    // store
    const store = useStore();

    // provider
    const provider = ref(store.state.user?.coy);

    // admission
    const admission = ref(false);

    // toolTip
    const toolTip = () => {
      var elems = document.querySelectorAll(".tooltipped");
      M.Tooltip.init(elems, {});
    };

    // restart toolTip
    const restartComments = () => {
      // load comment
      setTimeout(() => {
        toolTip();
      }, 2000);
    };

    // start comments
    onMounted(() => {
      restartComments();
    });

    // Duration (Month)
    const filterDurationMonthData = computed(() => {
      // start
      let val = null;

      let valPlus;

      if (responseDurationMonthDefault.value) {
        if (responseDurationMonthDefault.value.key == "filterDurationMonth") {
          valPlus = responseDurationMonthDefault.value.value.reduce(
            (newArr, x) => {
              newArr[x.period] = null;
              return newArr;
            },
            {}
          );
          val = { ...val, ...valPlus };
        }
      }

      // return final
      return val;
    });

    // Duration (Year)
    const filterDurationYearData = computed(() => {
      // start
      let val = null;

      let valPlus;

      if (responseDurationYearDefault.value) {
        if (responseDurationYearDefault.value.key == "filterDurationYear") {
          valPlus = responseDurationYearDefault.value.value.reduce(
            (newArr, x) => {
              newArr[x.period] = null;
              return newArr;
            },
            {}
          );
          val = { ...val, ...valPlus };
        }
      }

      // return final
      return val;
    });

    // filter (Initialize)
    onMounted(() => {
      // initialize filterDuration
      let val = [
        { period: "January", month: 1 },
        { period: "February", month: 2 },
        { period: "March", month: 3 },
        { period: "April", month: 4 },
        { period: "May", month: 5 },
        { period: "June", month: 6 },
        { period: "July", month: 7 },
        { period: "August", month: 8 },
        { period: "September", month: 9 },
        { period: "October", month: 10 },
        { period: "November", month: 11 },
        { period: "December", month: 12 },
      ];
      // set
      responseDurationMonthDefault.value = {
        key: "filterDurationMonth",
        value: val,
      };
    });

    // filter (Initialize)
    onMounted(() => {
      // initialize filterDuration
      let val = [
        { period: props.cluster.year.search, year: props.cluster.year.search },
        { period: props.cluster.year.search + 1, year: props.cluster.year.search + 1 },
      ];
      // set
      responseDurationYearDefault.value = {
        key: "filterDurationYear",
        value: val,
      };
    });

    // start
    onMounted(() => {
      // check reload
      if (props.encounter) {
        // re-set
        response.value = props.encounter;
      }
    });

    //from functions
    const capWords = (val) => {
      return capWordsFx(val == null ? "" : String(val));
    };

    // total calculations
    const totalSent = () => {
      if (claims.value?.length) {
        return totalSentInputFx({ claims: claims.value });
      } else {
        return 0;
      }
    }

    const formatClaimAmount = (claimItem) => {
      const amount = claimItem?.amt ?? claimItem?.sent_price ?? 0;
      return String(amount).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };

    // get function
    const getSearchItemsFromApi = (table, match) => {
      // loading starts
      isLoading.value = true;
      // clear error
      error.value = null;

      (async () => {
        const { res } = await getItemsOfItems(table, match);

        if (res.value && res.value.status) {
          if (res.value.data.length === 1) {
            // display the options (go straight)
            response.value = res.value.data[0];
          } else {
            // display the options
            enrolleeGroup.value = res.value.data;
          }
        } else {
          error.value = `Enrollee not on ${props.cluster.month.name} ${props.cluster.year.name} List!`;
          response.value = null; // clear standing response
        }

        // page is ready, loading is complete
        isLoading.value = false;
      })();
    };

    // ageSex
    const showAgeSex = (dob, sex) => {
      const validDob = dob && Number.isFinite(new Date(dob).getTime()) ? dob : null;
      const { fx } = ageSex(validDob, sex == null ? null : String(sex));
      return fx.value;
    };

    // download
    const handleDownload = async () => {
      // set admission
      if (toMidnightUTC(response.value.encounter_date_end) > toMidnightUTC(response.value.encounter_date)) {
        admission.value = true;
      }

      // Wait for the next tick to ensure the child component is fully rendered
      await nextTick();

      // Call the downloadPdf method in the child component
      if (healthClaimForm.value) {
        healthClaimForm.value.downloadPdf();
      } else {
        console.error('Child component is not available.');
      }
    }

    // clear all special
    const clearAllSpecial = () => {
      // clear
      doctor.value = null;
      patientAge.value = null;
      presentingComplaint.value = null;
      examinationFinding.value = null;
      requestedInvestigation.value = null;
    }

    // start
    const handleStart = (val) => {
      // set
      response.value = val;
    }

    // add enrollee (Manual)
    const handleAddEnrollee = () => {
     response.value = {
      enrollee_number: normalizeEnrolleeNumber(enrolleeId.value),
      name: enrolleeName.value,
      payer_id: props.cluster.payer_id,
      scheme: props.cluster.scheme,
      scheme_id: props.cluster.scheme_id,
     }

     console.log(response.value);
    }

    // search
    const handleSearch = () => {
      // loading starts
      isLoading.value = true;
      // val
      let date = props.cluster.month_year.split("_");
      let val = `payer_id=${props?.cluster?.payer_id}&scheme_id=${props?.cluster?.scheme_id}&m=${date[0]}&y=${date[1]}&q=${encodeURIComponent(normalizeEnrolleeSearchValue(enrolleeId.value))}`;
      // search: 0 = provider_id
      getSearchItemsFromApi("operator/enrollee/encounter/checker", `0?${val}`);
    };

    // to Mid night
    const toMidnightUTC = (date) => {
      const d = new Date(date);
      return new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
    };

    const isProfessionalFeeClaim = (claim) => {
      return claim?._professional_fee_preview || claim?.stores?.system_generated === "professional_fee";
    };

    const hasClaimAuthorization = (claim) => {
      return claim?.authorization === "y" || !!claim?.authorization_code;
    };

    const activeNormalClaims = (claimItems) => {
      return (claimItems || []).filter(x => x?.status === "a" && !isProfessionalFeeClaim(x));
    };

    const claimProfessionalFeeBase = (claim) => {
      if (claim?.authorization === "y") {
        const stores = claim?.stores || {};
        const authorizedAmount = stores?.auth_original?.approved_price
          ?? stores?.approved_price
          ?? claim?.approved_price;

        return Math.max(0, Number(authorizedAmount || 0));
      }

      return Math.max(0, Number(claim?.amt || claim?.sent_price || 0));
    };

    const isAdmissionEncounter = (encounter) => {
      if (!encounter?.encounter_date || !encounter?.encounter_date_end) {
        return false;
      }

      const start = toMidnightUTC(encounter.encounter_date).getTime();
      const end = toMidnightUTC(encounter.encounter_date_end).getTime();
      return Number.isFinite(start) && Number.isFinite(end) && start !== end;
    };

    const professionalFeePercentage = () => {
      return Number(props.cluster?.scheme?.professional_fee_percentage || 0);
    };

    const withProfessionalFeeClaim = (claimItems, encounter = response.value) => {
      const normalClaims = activeNormalClaims(claimItems);
      const inactiveClaims = (claimItems || []).filter(x => x?.status !== "a" && !isProfessionalFeeClaim(x));
      const existing = (claimItems || []).find(x => isProfessionalFeeClaim(x));
      const percentage = professionalFeePercentage();

      if (!percentage || percentage <= 0 || !isAdmissionEncounter(encounter) || !normalClaims.length) {
        return [...normalClaims, ...inactiveClaims];
      }

      const base = normalClaims.reduce((total, claim) => total + claimProfessionalFeeBase(claim), 0);
      const amount = Number(base * (percentage / 100)).toFixed(2);
      const professionalFeeClaim = {
        ...(existing || {}),
        id: existing?.id || `professional-fee-${encounter?.id || "draft"}`,
        claim: "Professional Fee",
        item: "Professional Fee",
        qty: 1,
        sent_qty: 1,
        amt: amount,
        sent_price: amount,
        standard: amount,
        standard_price: amount,
        authorization: "n",
        status: "a",
        stores: {
          ...(existing?.stores || {}),
          system_generated: "professional_fee",
          professional_fee_percentage: percentage,
          professional_fee_base: Number(base).toFixed(2),
        },
        _professional_fee_preview: !existing?.created_at,
      };

      return [...normalClaims, professionalFeeClaim, ...inactiveClaims];
    };

    // encounter start
    const handleEncounterDate = () => {
      // clear error
      // Error
      error.value = null;

      // Create a new Date object
      var date = new Date(
        Date.UTC(
          props.cluster.year.search,
          props.cluster.month.search - 1,
          encounterDate.value,
          0,
          0,
          0
        )
      );

      // Check validity of Date
      if (
        date.getFullYear() == props.cluster.year.search &&
        date.getMonth() == props.cluster.month.search - 1 &&
        date.getDate() == encounterDate.value
      ) {
        // Format the date
        var formattedDate = date.toISOString().slice(0, 19).replace("T", " ");

        // Set encounter date
        response.value.encounter_date = formattedDate;

        // start encounter day
        encounterDateEnd.value = date.getDate();

        // cluster month
        let clusterMonth = responseDurationMonthDefault.value.value.find(x => x.month === props.cluster.month.search);

        // month
        selectedDurationMonth.value = {
          name: clusterMonth.period,
          search: props.cluster.month.search,
        };

        // year
        selectedDurationYear.value = {
          name: props.cluster.year.search,
          search: props.cluster.year.search,
        };

      } else {
        error.value = "Date is Invalid!";
      }
    };

    // encounter end
    const handleEncounterDateEnd = async () => {
      // clear error
      // Error
      error.value = null;

      // Create a new Date object
      var date = new Date(
        Date.UTC(
          selectedDurationYear.value.search,
          selectedDurationMonth.value.search - 1,
          encounterDateEnd.value,
          0,
          0,
          0
        )
      );

      // Check validity of Date
      if (
        date.getFullYear() == selectedDurationYear.value.search &&
        date.getMonth() == selectedDurationMonth.value.search - 1 &&
        date.getDate() == encounterDateEnd.value
      ) {
        // Format the date
        var formattedDate = date.toISOString().slice(0, 19).replace("T", " ");
        // check is date is properly set
        if (toMidnightUTC(formattedDate) < toMidnightUTC(response.value.encounter_date)) {
          // Error
          error.value = "Encounter Date End is Invalid!";
        } else {

          // PRIVATE BYPASS ADDONS
          // if (props?.encounter?.scheme_id === 1) { addOns.value = true }

          // MOVE FROM HERE 
          // ORANGHIS == 3
          if (addOns.value || props?.encounter?.scheme_id !== 3) { // after special has been included!

            // start
            isLoading.value = true;

            // stores
            let newStores = { ...response.value?.stores }
            newStores.doctor = doctor.value;
            newStores.age = patientAge.value;
            newStores.complaint = presentingComplaint.value;
            newStores.finding = examinationFinding.value;
            newStores.investigation = requestedInvestigation.value;
            // all others are kept intact!

            // save encounter after end encounter date set
            if (response.value?.encounter_date_set) {

              // function
              if (response.value.status === "q") {

                // start
                const newVal = {
                  id: response.value.id,
                  encounter_date_end: formattedDate,
                  stores: newStores,
                  // status: "p", // set away from q
                };

                // post item
                const { res } = await putItem(
                  "encounter",
                  response.value.id,
                  newVal,
                );

                if (res.value) {
                  // reset entire encounter data
                  response.value = res.value.data;
                  emitEncounterUpdated();
                  // kill addOns
                  addOns.value = false;
                  // clear
                  clearAllSpecial();
                } else {
                  error.value = "Sorry, something wet wrong!";
                }

              }

            } else {
              // new encounter
              response.value.encounter_date_end = formattedDate;
              response.value.encounter_cluster_id = props.cluster.id,
              response.value.provider_id = props.cluster.provider_id,
              response.value.stores = newStores;
              response.value.status = "n"; // new
              // kill addOns
              addOns.value = false;
              // clear
              clearAllSpecial();
            }

            // end
            isLoading.value = false;

          } else {
            // addOns
            addOns.value = true;
            // addOns
            let newStores = { ...response.value?.stores }
            if (newStores?.doctor) { doctor.value = newStores?.doctor }
            if (newStores?.age) { patientAge.value = newStores?.age }
            if (newStores?.complaint) { presentingComplaint.value = newStores?.complaint }
            if (newStores?.finding) { examinationFinding.value = newStores?.finding }
            if (newStores?.investigation) { requestedInvestigation.value = newStores?.investigation }
          }

        }

      } else {
        error.value = "Date is Invalid!";
      }
    };

    // handle special
    const handleSpecial = () => {
      handleEncounterDateEnd();
    }

    // handle add on
    const handleAddOn = async () => {

      // start
      isLoading.value = true;

      // stores
      let newStores = { ...response.value?.stores }
      newStores.doctor = doctor.value;
      newStores.age = patientAge.value;
      newStores.complaint = presentingComplaint.value;
      newStores.finding = examinationFinding.value;
      newStores.investigation = requestedInvestigation.value;

      // start
      const newVal = {
        id: response.value.id,
        stores: newStores,
      };

      // post item
      const { res } = await putItem(
        "encounter",
        response.value.id,
        newVal,
      );

      if (res.value) {
        // reset entire encounter data
        response.value = res.value.data;
        emitEncounterUpdated();
        // clear
        doctor.value = null;
        patientAge.value = null;
        presentingComplaint.value = null;
        examinationFinding.value = null;
        requestedInvestigation.value = null;
      } else {
        error.value = "Sorry, something wet wrong!";
      }

      // end
      isLoading.value = false;
    }

    // handle addon review
    const handleReviewAddOn = () => {
      // stores
      let newStores = { ...response.value?.stores }
      doctor.value = newStores?.doctor;
      patientAge.value = newStores?.age;
      presentingComplaint.value = newStores?.complaint;
      examinationFinding.value = newStores?.finding;
      requestedInvestigation.value = newStores?.investigation;
      // remove store
      // newStores.doctor = null;
      // newStores.age = null;
      // newStores.complaint = null;
      // newStores.finding = null;
      // finish
      // response.value.stores = { ...newStores }
    }

    // date reset
    const handleDateReset = () => {
      // memory (aproko Vue)
      cache.value.encounter_date = response.value.encounter_date;
      // delete start date
      delete response.value.encounter_date;
      // memory (aproko Vue)
      cache.value.encounter_date_end = response.value.encounter_date_end;
      // delete end date
      delete response.value.encounter_date_end;
      // clear date values
      handleClearID("date");
    }

    // haandle clear
    const handleClearID = (val) => {
      if (val == "id") {
        enrolleeGroup.value = [];
        enrolleeId.value = null;
        enrolleeName.value = null;
        response.value = null;
        error.value = false;
      }

      if (val == "date") {
        encounterDate.value = null;
        encounterDateEnd.value = null;
        error.value = false;
      }
    };

    // handle Emitted update
    const handleUpdate = (val) => {
      claimsDisplayCard.value = val.claimsDisplayCard;
      claimsSubmitCard.value = val.claimsSubmitCard;
      diagnosisList.value = [...val.diagnosisList];
      submitPulse.value = val.submitPulse;
      deleteId.value = val.deleteId;
      if (deleteId.value) {
        pendingDeleteId.value = null;
      }
      cache.value = val.cache;
      if (response.value) {
        if (!response.value.encounter_date_set) {
          response.value.diagnosis = diagnosisList.value.join(", ");
        }
      }

      if (hasBillingDiagnosis()) {
        completionError.value = "";
      }

      if (response.value && diagnosisList.value.length && props.cluster?.status === "q" && !response.value?.encounter_date_set) {
        context.emit("draft", {
          ...response.value,
          claims: withProfessionalFeeClaim(claimsList.value),
          diagnosis: diagnosisList.value.join(", "),
          _draft: true,
        });
      }
    };

    const handleClaimsUpdated = (payload) => {
      const claimItems = Array.isArray(payload?.claims) ? payload.claims : [];
      claimsList.value = claimItems.filter(x => !isProfessionalFeeClaim(x));

      if (!response.value) return;

      response.value.claims = withProfessionalFeeClaim(claimsList.value);

      if (!payload?.changed) return;

      if (response.value.encounter_date_set) {
        emitEncounterUpdated();
        return;
      }

      if (diagnosisList.value.length && props.cluster?.status === "q") {
        context.emit("draft", {
          ...response.value,
          claims: response.value.claims,
          diagnosis: diagnosisList.value.join(", "),
          _draft: true,
        });
      }
    };

    const handleDiagnosisSaved = (savedEncounter) => {
      if (!response.value || !savedEncounter) return;

      const currentClaims = response.value.claims;
      response.value = {
        ...response.value,
        ...savedEncounter,
        claims: currentClaims,
      };

      const savedDiagnosis = String(response.value.diagnosis || "").trim();
      diagnosisList.value = savedDiagnosis ? [savedDiagnosis] : [];

      if (savedDiagnosis) {
        completionError.value = "";
      }

      emitEncounterUpdated();
    };

    const handleRemoveEmptyEncounter = async () => {
      if (!canRemoveEmptyEncounter.value || isRemovingEncounter.value) return;

      isRemovingEncounter.value = true;
      removeEncounterError.value = "";

      const removedEncounterId = response.value.id;
      const result = await removeEmptyBillingEncounter(props.cluster.id, removedEncounterId);

      if (result.data) {
        context.emit("removed", {
          encounterId: removedEncounterId,
          encounter: result.data,
        });
      } else {
        removeEncounterError.value = result.error;
        confirmEmptyEncounterRemoval.value = false;
      }

      isRemovingEncounter.value = false;
    };

    // handle edit
    const handleEdit = (val) => {
      pendingDeleteId.value = null;
      claim.value = { action: "edit", claim: val };
      editId.value = val.id;

      // top
      router.push({ hash: "#claim" });
    };

    // request delete
    const handleDeleteRequest = (val) => {
      pendingDeleteId.value = pendingDeleteId.value == val.id ? null : val.id;
    };

    // confirm delete
    const handleDeleteConfirm = (val) => {
      pendingDeleteId.value = null;
      handleDelete(val);
    };

    // cancel delete
    const handleDeleteCancel = () => {
      pendingDeleteId.value = null;
    };

    // handle delete
    const handleDelete = (val) => {
      pendingDeleteId.value = null;
      claim.value = { action: "delete", claim: val };
    };

    // handle remove (passed as props)
    const handleReviewDiagnosis = async () => {
      resetDiagnosis.value = true;
      await nextTick();

      const editorCard = diagnosisEditor.value?.querySelector(".provider-diagnosis-card");
      if (!editorCard) return;

      const top = editorCard.getBoundingClientRect().top + window.scrollY - 104;
      window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
    };

    // handle next
    const handleNext = (val) => {
      next.value = val;

      // top
      router.push({ hash: "#claim" });
    };

    // continue review from the lower helper without moving the viewport
    const handleContinueReviewInPlace = () => {
      next.value = "review";
    };

    // handle clear (emiited)
    const handleClear = (val) => {
      if (val.id == "resetDiagnosis") {
        resetDiagnosis.value = val.value;
      } else if (val.id == "claim") {
        claim.value = val.value;
      } else if (val.id == "next") {
        next.value = val.value;
      } else if (val.id == "editId") {
        editId.value = val.value;
      }
    };

    // enrollee delete
    const handleDeleteEncounter = async (val) => {
      if (val === "delete") {

        // send to confirm
        forDelete.value = true;
        // active buttons
        isSubmitting.value = false;

      } else if (val === "confirm_delete") {

        // disable buttons
        isSubmitting.value = true;
        context.emit("draft-clear", true);
        // set as delete

        // enrollee without authorization approved
        if (enrollee.value?.encounter_date_set && !enrollee.value?.claims?.find(x => x.authorization === 'y')) {
          const result = await removeEmptyBillingEncounter(props.cluster.id, enrollee.value.id);

          if (!result.data) {
            removeEncounterError.value = result.error;
            forDelete.value = false;
            isSubmitting.value = false;
            return;
          }

          response.value.status = "d";
        }

        // new encounter
        if (!enrollee.value?.encounter_date_set) {
          // clear new
          response.value = null;
        }

        // submit
        await handleSubmit(true, false);

      } else if (val === "back") {

        // clear
        forDelete.value = false;
        // active buttons
        isSubmitting.value = false;

      }
    }

    // handleCreate
    const handleCreate = async () => {
      if (!hasBillingDiagnosis()) {
        await requireBillingDiagnosis();
        return;
      }

      // start
      isSubmitting.value = true;
      isLoading.value = true;
      completionError.value = "";
      // clear error
      error.value = false;

      // if not saved
      if (!enrollee.value?.encounter_date_set) {
        // update encounter
        response.value.diagnosis = diagnosisList.value.join(", ");
        response.value.claims = withProfessionalFeeClaim(claimsList.value);
        // grab non-reactive copy
        const enrolleeCopy = JSON.parse(JSON.stringify(enrollee.value));
        // create
        let newVal = await addEncounterWithClaims(enrolleeCopy);
        if (newVal?.data) {
          let updatedVal = newVal.data;
          // load update  
          updatedVal.claims.forEach((claim) => {
                    claim.claim = claim.item
                    claim.qty = claim.sent_qty
                    claim.amt = claim.sent_price
                    claim.standard = claim.standard_price
                });
          // set response
          response.value = updatedVal;    
          // send away          
          await handleSubmit(true, true);
        } else {
          error.value = newVal?.error || "Sorry, Something went wrong!"; // stay
        }

      }

      // end
      isSubmitting.value = false;
      isLoading.value = false;

    }

    // final submit
    const handleBack = () => {
      // send out  
      setTimeout(function () {
        context.emit("back", {
          encounter: response.value,
        });
        // end
        isLoading.value = false;
      }, 10);
    };

    // final submit
    const handleSubmit = async (submit, allowStatusTransition = false) => {

      if (
        submit
        && allowStatusTransition
        && response.value?.encounter_date_set
        && response.value?.status === "q"
        && !hasBillingDiagnosis()
      ) {
        await requireBillingDiagnosis();
        return;
      }

      completionError.value = "";

      // set pass
      let pass = true;

      // start loading
      isLoading.value = true;

      // save encounter after end encounter date set
      if (response.value?.encounter_date_set && submit && allowStatusTransition) {

        // function
        if (response.value.status === "q") {

          // reset pass
          pass = false;
          // start submission
          isSubmitting.value = true;

          // start
          const newVal = {
            id: response.value.id,
            status: "p", // set away from q
          };

          // post item
          const { res, err } = await putItem(
            "encounter",
            response.value.id,
            newVal,
          );

          if (res.value) {
            // reset entire encounter data
            response.value.status = res.value.data.status;
            // reset pass
            pass = true;
          } else {
            completionError.value = err.value || "The encounter could not be submitted.";
          }

        }

      }

      // go
      if (pass) {
        context.emit("next", {
          encounter: enrollee.value,
          submit: submit,
        });
      }

      // end
      isSubmitting.value = false;
      isLoading.value = false;

    };

    // output results
    const enrollee = computed(() => {
      if (!response.value) {
        return null;
      } else {
        return response.value;
      }
    });

    const canReviewDiagnosis = computed(() => {
      return props.cluster?.status === "q"
        && (!enrollee.value?.encounter_date_set || enrollee.value?.status === "q" || enrollee.value?.status === "n");
    });

    // output claims results
    const claims = computed(() => {
      if (!claimsList.value) {
        return [];
      } else {
        return withProfessionalFeeClaim(claimsList.value);
      }
    });

    // get option
    const handlePick = (val) => {
      selectedItem.value = val;
      // watchEffect will take over from here
    };

    // search watcher
    watchEffect(() => {
      // start
      if (selectedItem.value) {
        // sort
        if (selectedItem.value.id == "filterDurationMonth") {
          //set
          if (!selectedItem.value.value) {
            selectedDurationMonth.value = null;
          } else {
            responseDurationMonthDefault.value.value.forEach((x) => {
              if (x.period == selectedItem.value.value) {
                // found
                selectedDurationMonth.value = {
                  name: x.period,
                  search: x.month,
                };
              }
            });
          }
        } else if (selectedItem.value.id == "filterDurationYear") {
          //set
          if (!selectedItem.value.value) {
            selectedDurationYear.value = null;
          } else {
            responseDurationYearDefault.value.value.forEach((x) => {
              if (x.period == selectedItem.value.value) {
                // found
                selectedDurationYear.value = { name: x.period, search: x.year };
              }
            });
          }
        }
      }
    });


    return {
      lock,
      enrolleeSearch,
      healthClaimForm,
      isManualBillingCluster,
      tariffLookup,
      error,
      isLoading,
      isSubmitting,
      capWords,
      showAgeSex,
      handleDownload,
      handleStart,
      handleAddEnrollee,
      handleSearch,
      handlePick,
      handleDateReset,
      handleEncounterDate,
      handleEncounterDateEnd,
      handleSpecial,
      handleAddOn,
      handleReviewAddOn,
      handleClearID,
      handleEdit,
      handleDeleteRequest,
      handleDeleteConfirm,
      handleDeleteCancel,
      handleReviewDiagnosis,
      handleDelete,
      handleUpdate,
      handleClaimsUpdated,
      handleDiagnosisSaved,
      handleRemoveEmptyEncounter,
      handleNext,
      handleContinueReviewInPlace,
      handleDeleteEncounter,
      handleCreate,
      handleBack,
      handleSubmit,
      handleClear,
      totalSent,
      formatClaimAmount,
      isProfessionalFeeClaim,
      hasClaimAuthorization,
      editId,
      deleteId,
      pendingDeleteId,
      forDelete,
      claimsDisplayCard,
      claimsSubmitCard,
      selectedItem,
      filterDurationMonthData,
      filterDurationYearData,
      selectedDurationMonth,
      selectedDurationYear,
      resetDiagnosis,
      diagnosisEditor,
      completionError,
      confirmEmptyEncounterRemoval,
      isRemovingEncounter,
      removeEncounterError,
      canRemoveEmptyEncounter,
      canReviewDiagnosis,
      billingDiagnosisList,
      diagnosisList,
      editClaim,
      deleteClaim,
      submitPulse,
      claimsList,
      next,
      type,
      claim,
      claims,
      enrolleeGroup,
      enrolleeId,
      enrolleeName,
      enrollee,
      encounterDate,
      encounterDateEnd,
      addOns,
      doctor,
      patientAge,
      presentingComplaint,
      examinationFinding,
      requestedInvestigation,
      provider,
      admission,
    };
  },
};
</script>

<style scoped>
.progress {
  margin-top: -15px;
}

.billing-completion-error {
  background: #fff4f2;
  border: 1px solid #ef9a9a;
  color: #b71c1c;
  margin: 0 0 14px;
  padding: 12px 16px;
}

.progresss {
  margin-top: -10px;
}

.progresssave {
  margin-top: -15px;
}

.billing-enrollee-detail {
  padding: 0;
  overflow: visible;
}

.billing-work-card {
  background: transparent;
  box-shadow: none;
  overflow: visible;
  position: relative;
  z-index: 2;
}

.billing-member-panel {
  border: 2px solid #bfd2da;
  border-radius: 0;
  background: linear-gradient(90deg, #fafcfc 0%, #fff 48%);
  box-shadow: 0 4px 14px rgba(38, 50, 56, 0.08);
  padding: 28px 34px;
  margin-bottom: 16px;
}

.billing-member-panel .row {
  margin-bottom: 0;
  overflow: visible;
}

.billing-member-client {
  color: #607d8b;
  font-weight: 700;
  margin: 0 0 8px;
}

.billing-member-panel h5 {
  color: #263238;
  font-size: 1.65rem;
  font-weight: 800;
  line-height: 1.15;
  margin: 0 0 12px;
}

.billing-member-panel sup {
  color: #000;
  font-size: 0.62em;
  font-weight: 800;
}

.billing-member-id {
  display: inline-flex;
  align-items: center;
  border: 1px solid #d7e5ea;
  border-radius: 0;
  color: #455a64;
  font-size: 1rem;
  font-weight: 700;
  min-height: 38px;
  padding: 7px 14px;
  margin: 0;
  background: rgba(255, 255, 255, 0.86);
}

.billing-member-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border: 1px solid #ffb76a;
  border-radius: 4px;
  background: #fff8f1;
  box-shadow: 0 2px 6px rgba(239, 108, 0, 0.12);
  color: #d95f00;
  vertical-align: middle;
  transition: background-color 160ms ease, border-color 160ms ease, color 160ms ease;
}

.billing-member-close:hover,
.billing-member-close:focus {
  background: #fff1e3;
  border-color: #ef6c00;
  color: #b94f00;
  outline: none;
}

.billing-member-close i {
  background: transparent !important;
  color: inherit;
  font-size: 1.65rem;
}

.billing-member-panel img {
  width: 96px;
  height: 96px;
  object-fit: cover;
  background: #e0e0e0;
}

.billing-delete-panel,
.billing-operation-panel,
.billing-enrollee-option {
  border: 1px solid #d6e5ea;
  border-radius: 0;
  background: #fff;
  box-shadow: none;
  overflow: visible;
  position: relative;
  z-index: 4;
}

.billing-operation-panel {
  padding: 24px;
}

.billing-operation-panel .row {
  margin-bottom: 0;
  overflow: visible;
}

.billing-operation-panel .input-field {
  overflow: visible;
  position: relative;
  z-index: 20;
}

.billing-operation-panel :deep(.dropdown-content),
.billing-operation-panel :deep(.autocomplete-content.dropdown-content) {
  max-height: 360px;
  overflow-y: auto;
  z-index: 1200;
}

.billing-inline-summary {
  border: 1px solid #d6e5ea;
  border-radius: 0;
  background: #fbfdfd;
  margin-top: 14px;
}

.billing-clinical-stack {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 18px 0 14px;
}

.billing-clinical-stack > .col {
  float: none;
  width: 100%;
  padding: 0;
}

.billing-diagnosis-card,
.billing-addon-card {
  width: 100%;
  border: 1px solid #d6e5ea;
  border-radius: 0;
  background: #fbfdfd;
  min-height: 76px;
  padding: 18px 20px;
  display: flex;
  align-items: center;
  gap: 16px;
}

.billing-diagnosis-card {
  border: 2px solid #bfd2da;
  box-shadow: 0 4px 14px rgba(38, 50, 56, 0.08);
}

.billing-diagnosis-card span {
  display: block;
  min-width: 0;
  width: 100%;
}

.billing-diagnosis-card small {
  display: block;
  color: #607d8b;
  font-size: 0.76rem;
  font-weight: 800;
  letter-spacing: 0;
  text-transform: uppercase;
  margin-bottom: 3px;
}

.billing-diagnosis-card strong {
  display: block;
  color: #263238;
  font-size: 1.05rem;
  line-height: 1.35;
  overflow-wrap: anywhere;
}

.billing-card-icon {
  width: 48px;
  height: 48px;
  border-radius: 0;
  background: #e8f5f5;
  color: #00897b;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
}

.billing-diagnosis-card .edit-black-item {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border: 1px solid #d6e5ea;
  border-radius: 0;
  background: #fff;
  margin-left: 12px;
}

.billing-addon-card {
  display: block;
  color: #455a64;
  line-height: 1.45;
}

.billing-add-provider-frame {
  margin: 12px 0 18px;
  overflow: visible;
  position: relative;
  z-index: 3;
}

.billing-add-provider-frame :deep(.card),
.billing-add-provider-frame :deep(.card-panel),
.billing-add-provider-frame :deep(.card-content) {
  border-radius: 0;
  box-shadow: none;
  overflow: visible;
}

.billing-add-provider-frame :deep(.provider-diagnosis-card),
.billing-add-provider-frame :deep(.provider-claim-add-card) {
  background: #ffffff !important;
  border: 1px solid #d6e5ea;
  border-radius: 0 !important;
  box-shadow: none !important;
  margin: 16px auto 18px;
  width: 100%;
}

.billing-add-provider-frame :deep(.provider-diagnosis-card .card-content),
.billing-add-provider-frame :deep(.provider-claim-add-card .card-content) {
  padding: 28px 36px;
}

.billing-add-provider-frame :deep(.card > .card-content) {
  padding: 28px 36px;
}

.billing-add-provider-frame :deep(.provider-claim-add-card.teal.lighten-5),
.billing-add-provider-frame :deep(.provider-claim-add-card.red.lighten-5),
.billing-add-provider-frame :deep(.card.teal.lighten-5),
.billing-add-provider-frame :deep(.card.red.lighten-5) {
  background: #ffffff !important;
}

.billing-add-provider-frame :deep(.provider-claim-add-card .card-title) {
  color: #263238;
  display: flex;
  font-size: 1.45rem;
  font-weight: 500;
  line-height: 1.25;
  margin-bottom: 16px;
}

.billing-add-provider-frame :deep(.card .card-title) {
  color: #263238;
  display: flex;
  font-size: 1.45rem;
  font-weight: 500;
  line-height: 1.25;
  margin-bottom: 16px;
}

.billing-add-provider-frame :deep(.provider-claim-add-card .input-field) {
  margin-bottom: 14px;
  overflow: visible;
  position: relative;
  z-index: 20;
}

.billing-add-provider-frame :deep(.card .input-field:not(.col.s12:last-child)) {
  margin-bottom: 14px;
  overflow: visible;
  position: relative;
  z-index: 20;
}

.billing-add-provider-frame :deep(.provider-claim-add-card input:not([type])) ,
.billing-add-provider-frame :deep(.provider-claim-add-card input[type=text]),
.billing-add-provider-frame :deep(.provider-claim-add-card input[type=number]) {
  border-bottom-color: #90a4ae;
}

.billing-add-provider-frame :deep(.provider-claim-add-card label.active) {
  color: #78909c;
  font-weight: 500;
}

.billing-add-provider-frame :deep(.card label.active) {
  color: #78909c !important;
  font-weight: 500;
}

.billing-add-provider-frame :deep(.provider-claim-add-card .input-field.col.s12:last-child) {
  align-items: center;
  background: #f7fafb;
  border-top: 1px solid #e1e8eb;
  display: flex;
  gap: 14px;
  justify-content: space-between;
  margin: 8px 0 0;
  padding: 14px 16px;
}

.billing-add-provider-frame :deep(.card .input-field.col.s12:last-child) {
  align-items: center;
  background: #f7fafb;
  border-top: 1px solid #e1e8eb;
  display: flex;
  gap: 14px;
  justify-content: space-between;
  margin: 8px 0 0;
  padding: 14px 16px;
  position: relative;
  z-index: 1;
}

.billing-add-provider-frame :deep(.provider-claim-add-card .input-field.col.s12:last-child > .btn),
.billing-add-provider-frame :deep(.provider-claim-add-card .input-field.col.s12:last-child > .btn-large) {
  flex: 0 0 auto;
  width: auto !important;
}

.billing-add-provider-frame :deep(.card .input-field.col.s12:last-child > .btn),
.billing-add-provider-frame :deep(.card .input-field.col.s12:last-child > .btn-large) {
  flex: 0 0 auto;
  width: auto !important;
}

.billing-add-provider-frame :deep(.btn),
.billing-add-provider-frame :deep(.btn-large) {
  align-items: center;
  border-radius: 6px;
  box-shadow: none;
  display: inline-flex;
  font-weight: 800;
  gap: 8px;
  justify-content: center;
  letter-spacing: 0;
  margin: 0 !important;
  min-width: 138px;
  padding: 0 18px;
  text-transform: uppercase;
}

.billing-add-provider-frame :deep(.provider-claim-add-card .red.lighten-2) {
  background: #ffffff !important;
  border: 1px solid #ef9a9a;
  color: #c62828;
  margin-right: auto !important;
  order: 1;
}

.billing-add-provider-frame :deep(.card .red.lighten-2) {
  background: #ffffff !important;
  border: 1px solid #ef9a9a;
  color: #c62828;
  margin-right: auto !important;
  order: 1;
}

.billing-add-provider-frame :deep(.provider-claim-add-card .red.lighten-2 i) {
  color: #ef6c00;
}

.billing-add-provider-frame :deep(.card .red.lighten-2 i) {
  color: #ef6c00;
}

.billing-add-provider-frame :deep(.provider-claim-add-card .black) {
  background: #263238 !important;
  border: 1px solid #263238;
  color: #ffffff;
  order: 2;
}

.billing-add-provider-frame :deep(.provider-claim-add-card .blue) {
  background: #00897b !important;
  border: 1px solid #00897b;
  color: #ffffff;
  order: 3;
}

.billing-add-provider-frame :deep(.provider-claim-add-card .co1) {
  display: none;
}

.billing-add-provider-frame :deep(.provider-claim-add-card .left),
.billing-add-provider-frame :deep(.provider-claim-add-card .right) {
  float: none !important;
}

.billing-add-provider-frame :deep(.provider-claim-add-card .tariff-card-actions) {
  margin-left: auto;
}

.billing-add-provider-frame :deep(.autocomplete-content.dropdown-content),
.billing-add-provider-frame :deep(.dropdown-content) {
  max-height: 360px;
  overflow-y: auto;
  z-index: 1300;
}

.billing-add-provider-frame :deep(.collection),
.billing-add-provider-frame :deep(.collection-item) {
  border-color: #d6e5ea;
  border-radius: 0;
}

.billing-items-card {
  border: 1px solid #d6e5ea;
  border-radius: 0;
  background: #fff;
  box-shadow: none;
  margin-top: 18px;
}

.billing-back-row {
  display: flex;
  align-items: center;
  margin: 4px 0 18px;
  padding: 0 4px;
}

.billing-empty-encounter {
  border-top: 1px solid #e4eaed;
  margin: 20px 0 16px;
  padding: 18px 4px 0;
}

.billing-empty-encounter-trigger,
.billing-empty-encounter-cancel,
.billing-empty-encounter-remove {
  align-items: center;
  border: 0;
  cursor: pointer;
  display: inline-flex;
  font: inherit;
  gap: 8px;
}

.billing-empty-encounter-trigger {
  background: #ffebee;
  border: 1px solid #ef9a9a;
  border-radius: 4px;
  color: #b71c1c;
  font-weight: 700;
  padding: 9px 12px;
}

.billing-empty-encounter-trigger:disabled,
.billing-empty-encounter-cancel:disabled,
.billing-empty-encounter-remove:disabled {
  cursor: wait;
  opacity: 0.6;
}

.billing-empty-encounter-confirm {
  align-items: center;
  background: #fff8f7;
  border: 1px solid #ef9a9a;
  display: flex;
  justify-content: space-between;
  padding: 14px 16px;
}

.billing-empty-encounter-confirm p {
  color: #546e7a;
  margin: 4px 0 0;
}

.billing-empty-encounter-actions {
  display: flex;
  gap: 10px;
}

.billing-empty-encounter-cancel,
.billing-empty-encounter-remove {
  border-radius: 4px;
  font-weight: 700;
  min-height: 38px;
  padding: 8px 12px;
}

.billing-empty-encounter-cancel {
  background: #eceff1;
  color: #37474f;
}

.billing-empty-encounter-remove {
  background: #c62828;
  color: #fff;
}

.billing-empty-encounter-error {
  color: #b71c1c;
  margin: 10px 0 0;
}

.billing-back-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #455a64;
  font-size: 0.92rem;
  font-weight: 800;
  letter-spacing: 0;
  padding: 10px 6px;
}

.billing-back-link:hover,
.billing-back-link:focus {
  color: #00897b;
  text-decoration: underline;
}

.billing-back-link i {
  font-size: 21px;
  line-height: 1;
}

.billing-items-card .card-content {
  padding: 26px 32px;
}

.billing-add-state-helper {
  align-items: center;
  border-top: 1px solid #e1e8eb;
  display: flex;
  justify-content: center;
  margin-top: 14px;
  padding: 16px 0 0;
}

.billing-add-state-link {
  align-items: center;
  background: transparent;
  border: 0;
  color: #00897b;
  cursor: pointer;
  display: inline-flex;
  font: inherit;
  font-size: 0.92rem;
  font-weight: 800;
  gap: 6px;
  letter-spacing: 0;
  padding: 8px 12px;
}

.billing-add-state-link:hover,
.billing-add-state-link:focus {
  color: #00695c;
  text-decoration: underline;
}

.billing-add-state-link i {
  font-size: 20px;
  line-height: 1;
}

.billing-items-head {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
}

.billing-items-head .card-title {
  color: #263238;
  font-size: 1.15rem;
  font-weight: 800;
  line-height: 1.3;
}

.billing-item-list,
.billing-total-list {
  border: 0;
  margin: 0;
}

.billing-item-row {
  border: 1px solid #dce8ec !important;
  border-radius: 0;
  color: #263238;
  margin-bottom: 10px;
  padding: 18px 20px !important;
  min-height: 58px;
}

.billing-item-row b {
  font-weight: 800;
}

.billing-line-copy {
  display: block;
  min-width: 0;
  overflow-wrap: break-word;
}

.billing-auto-fee-badge {
  background: #e8f3f1;
  border: 1px solid #bfd9d5;
  color: #00897b;
  font-weight: 800;
  margin-left: 8px;
}

.billing-item-row .secondary-content {
  border-left: 1px solid #dce8ec;
  padding-left: 12px;
}

.billing-item-row.is-delete-pending {
  background: #fffdfb !important;
  border-color: #ffd8bd !important;
}

.billing-item-row.is-delete-pending .secondary-content.cancel-item {
  align-items: center;
  background: #fff7ef;
  border: 1px solid #ffcc9a;
  border-radius: 4px;
  display: inline-flex;
  height: 32px;
  justify-content: center;
  padding-left: 0;
  width: 34px;
}

.billing-item-row.is-delete-pending .secondary-content.cancel-item i {
  color: #f4511e !important;
  font-size: 20px;
  line-height: 1;
}

.claim-remove-confirm {
  align-items: center;
  background: #fff8f2;
  border: 1px solid #ffe0c2;
  border-radius: 4px;
  color: #546e7a;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
  padding: 8px 10px;
  width: fit-content;
}

.claim-remove-confirm > span {
  font-size: 0.88rem;
  font-weight: 600;
}

.claim-remove-confirm button {
  background: #ffffff;
  border: 1px solid #dbe5e9;
  border-radius: 999px;
  color: #455a64;
  cursor: pointer;
  font: inherit;
  font-size: 0.82rem;
  font-weight: 600;
  height: 30px;
  letter-spacing: 0;
  line-height: 1;
  padding: 0 12px;
}

.claim-remove-confirm .claim-remove-confirm-yes {
  border-color: #ffcdd2;
  color: #c62828;
}

.claim-remove-confirm .claim-remove-confirm-no {
  color: #607d8b;
}

.billing-total-row {
  border: 1px solid #dce8ec !important;
  border-radius: 0;
  background: #fbfdfd !important;
  color: #263238;
  margin-top: 12px;
  padding: 16px 20px !important;
}

.billing-action-strip {
  align-items: center;
  background: #f8fbfb;
  border: 1px solid #dce8ec;
  border-radius: 0;
  display: flex;
  gap: 16px;
  justify-content: space-between;
  margin: 18px 0 0;
  padding: 16px 18px;
}

.billing-action-strip br,
.billing-action-strip .co1 {
  display: none;
}

.billing-action-left-group {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.billing-action-button {
  align-items: center;
  border-radius: 6px;
  box-shadow: none;
  display: inline-flex;
  font-size: 0.86rem;
  font-weight: 800;
  gap: 8px;
  gap: 10px;
  height: 46px;
  justify-content: center;
  letter-spacing: 0;
  line-height: 1;
  margin: 0 !important;
  min-width: 132px;
  padding: 0 18px;
  text-transform: uppercase;
}

.billing-action-button i,
.billing-action-button span {
  align-items: center;
  display: inline-flex;
}

.billing-action-button span {
  gap: 8px;
}

.billing-action-button i {
  font-size: 22px;
  line-height: 22px;
  margin: 0;
}

.billing-enrollee-option {
  background: #ffffff;
}

.billing-option-action {
  align-items: center;
  border: 1px solid rgba(38, 50, 56, 0.12);
  border-radius: 0;
  box-shadow: none;
  display: inline-flex;
  justify-content: center;
}

.billing-danger-action,
.billing-dark-action,
.billing-primary-action {
  border: 1px solid rgba(38, 50, 56, 0.12);
}

.billing-danger-action {
  background: #ffffff !important;
  border-color: #ef9a9a;
  color: #b71c1c;
}

.billing-danger-action i {
  color: #c62828;
}

.billing-dark-action {
  background: #263238 !important;
  border-color: #263238;
  color: #ffffff;
}

.billing-primary-action {
  margin-left: auto !important;
  min-width: 168px;
}

.billing-primary-ready {
  background: #00897b !important;
  border-color: #00897b;
  color: #ffffff;
}

.billing-primary-muted {
  background: #78909c !important;
  border-color: #78909c;
  color: #ffffff;
}

.clickable {
  cursor: pointer;
}

.counter {
  display: block;
  border-radius: 50%;
  background-color: #f2f3f4;
  padding: 0.5em;
}

.spacer5 {
  padding-top: 5px;
  padding-bottom: 5px;
}

.spacer10 {
  padding-top: 10px;
  padding-bottom: 10px;
}

@media screen and (max-width: 720px) {
  .billing-empty-encounter-confirm,
  .billing-empty-encounter-actions {
    align-items: stretch;
    flex-direction: column;
  }

  .billing-empty-encounter-trigger,
  .billing-empty-encounter-cancel,
  .billing-empty-encounter-remove {
    justify-content: center;
    width: 100%;
  }

  .billing-member-panel {
    padding: 22px;
  }

  .billing-member-panel .col {
    width: 100%;
  }

  .billing-member-panel img {
    float: left !important;
    margin-top: 18px;
  }

  .billing-diagnosis-card,
  .billing-addon-card,
  .billing-items-card .card-content {
    padding: 18px;
  }

  .billing-action-strip {
    flex-direction: column;
    align-items: stretch;
  }

  .billing-action-left-group {
    flex-direction: column;
    width: 100%;
  }

  .billing-primary-action {
    margin-left: 0;
  }

  .billing-action-button {
    width: 100%;
  }
}
</style>
